import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import DashboardPage from "./pages/DashboardPage";
import FingerLimitsPage from "./pages/FingerLimitsPage";
import CardsPage from "./pages/CardsPage";
import DevicePlacesPage from "./pages/DevicePlacesPage";
import DeviceModelsPage from "./pages/DeviceModelsPage";
import DeviceTypesPage from "./pages/DeviceTypesPage";
import DeviceUsersPage from "./pages/DeviceUsersPage";
import EmployeesPage from "./pages/EmployeesPage";
import LocalStructuresPage from "./pages/LocalStructuresPage";
import RolesPage from "./pages/RolesPage";
import UsersPage from "./pages/UsersPage";
import { useSelector } from "react-redux";
import DutiesPage from "./pages/DutiesPage";
import DevicesPage from "./pages/DevicesPage";
import EmployeesReportPage from "./pages/EmployeesReportPage"
import BiometricReportPage from "./pages/BiometricReportPage"
import BiometricFacePage from "./pages/BiometricFacePage"
import SyncDataPage from "./pages/SyncDataPage"
import DevicesReportPage from "./pages/DevicesReportPage "
import DevicesFacilityReportPage from "./pages/DevicesFacilityReportPage"


export default function BasePage() {
  const permissionList = useSelector(state => state.auth.permissionList)

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {permissionList.some(element => element === "view_user") &&
          <Redirect exact from="/" to="/settings/dashboard" />
        }
        {permissionList.some(element => element === "view_duty") &&
          <Redirect exact from="/" to="/settings/duties" />
        }
        {permissionList.some(element => element === "view_limit") &&
          <Redirect exact from="/" to="/settings/finger-limits" />
        }
        {permissionList.some(element => element === "view_card") &&
          <Redirect exact from="/" to="/settings/cards" />
        }
        {permissionList.some(element => element === "view_device_place") &&
          <Redirect exact from="/" to="/settings/device-place" />
        }
        {permissionList.some(element => element === "view_device_model") &&
          <Redirect exact from="/" to="/settings/device-model" />
        }
        {permissionList.some(element => element === "view_device_type") &&
          <Redirect exact from="/" to="/settings/device-type" />
        }
         {permissionList.some(element => element === "view_device_user") &&
          <Redirect exact from="/" to="/settings/device-user" />
        }
        {permissionList.some(element => element === "view_role") &&
          <Redirect exact from="/" to="/settings/roles" />
        }
        {permissionList.some(element => element === "view_employee") &&
          <Redirect exact from="/" to="/employees" />
        }
        {permissionList.some(element => element === "view_local_structure") &&
          <Redirect exact from="/" to="/settings/local-structure" />
        }
        {permissionList.some(element => element === "view_user_permission") &&
          <Redirect exact from="/" to="/settings/users" />
        }
        {permissionList.some(element => element === "view_employee_log") &&
          <Redirect exact from="/" to="/reports/report-employees" />
        }
        {permissionList.some(element => element === "view_biometric_log") &&
          <Redirect exact from="/" to="/reports/biometric-report" />
        }
        {permissionList.some(element => element === "view_device_operation_report") &&
          <Redirect exact from="/" to="/reports/device-report" />
        }
        {permissionList.some(element => element === "view_sync") &&
          <Redirect exact from="/" to="/sync-data" />
        }
        {permissionList.some(element => element === "view_device") &&
          <Redirect exact from="/" to="/devices" />
        }
        {permissionList.some(element => element !== "view_device_report") &&
          <Redirect exact from="/" to="/reports/facility-operations-report" />
        }


        {permissionList.some(element => element !== "view_user") &&
          <ContentRoute path="/settings/dashboard" component={DashboardPage} />}
        {permissionList.some(element => element !== "view_duty") &&
          <ContentRoute path="/settings/duties" component={DutiesPage} />}

        {permissionList.some(element => element !== "view_limit") &&
          <ContentRoute path="/settings/finger-limits" component={FingerLimitsPage} />}

        {permissionList.some(element => element !== "view_card") &&
          <ContentRoute path="/settings/cards" component={CardsPage} />}
        {permissionList.some(element => element !== "view_device_place") && <ContentRoute path="/settings/device-place" component={DevicePlacesPage} />}
        {permissionList.some(element => element !== "view_device_model") && <ContentRoute path="/settings/device-model" component={DeviceModelsPage} />}
        {permissionList.some(element => element !== "view_device_type") && <ContentRoute path="/settings/device-type" component={DeviceTypesPage} />}
        {permissionList.some(element => element !== "view_device_user") && <ContentRoute path="/settings/device-user" component={DeviceUsersPage} />}
      
        {permissionList.some(element => element !== "view_employee") && <ContentRoute path="/employees" component={EmployeesPage} />}
        {permissionList.some(element => element !== "view_local_structure") && <ContentRoute path="/settings/local-structure" component={LocalStructuresPage} />}
        {permissionList.some(element => element !== "view_role") && <ContentRoute path="/settings/roles" component={RolesPage} />}
        {permissionList.some(element => element !== "view_user_permission") && <ContentRoute path="/settings/users" component={UsersPage} />}
        {permissionList.some(element => element === "view_device") &&
          <ContentRoute path="/devices" component={DevicesPage} />
        }
        {permissionList.some(element => element !== "view_employee_log") &&
          <ContentRoute path="/reports/report-employees" component={EmployeesReportPage} />}

        {permissionList.some(element => element !== "view_biometric_log") &&
          <ContentRoute path="/reports/biometric-report" component={BiometricReportPage} />
        }
         {permissionList.some(element => element !== "view_biometric_log") &&
          <ContentRoute path="/reports/biometric-face" component={BiometricFacePage} />
        }
        {permissionList.some(element => element !== "view_device_report") &&
          <ContentRoute path="/reports/facility-operations-report" component={DevicesFacilityReportPage} />}
        {permissionList.some(element => element !== "view_device_operation_report") &&
          <ContentRoute path="/reports/device-report" component={DevicesReportPage} />
        }
        {permissionList.some(element => element !== "view_sync") &&
          <ContentRoute path="/sync-data" component={SyncDataPage} />
        }
        {!permissionList.length &&
          <Redirect to="/logout" />}
        {/* <Redirect to="/logout" /> */}
        <Redirect to="error/error-v5" />
      </Switch>
    </Suspense>
  );
}
